import React from "react";
function FloatingInput({
  name,
  label,
  value,
  checked,
  options,
  onChange,
  type,
  className,
  style,
  tooltip,
  placeholder,
  rows,
  ...rest
}) {
  const inputType = () => {
    switch (type) {
      case "datetime-local":
        return (
          <input
            {...rest}
            type="datetime-local"
            name={name}
            id={name}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            className={
              className ? `${className} form-control m-1` : "form-control m-1"
            }
            style={style}
          />
        );
      case "textarea":
        return (
          <textarea
            {...rest}
            name={name}
            id={name}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            className={
              className ? `${className} form-control m-1` : "form-control m-1"
            }
            style={style}
          />
        );
      case "select":
        return (
          <select
            name={name}
            id={name}
            placeholder={placeholder}
            value={value || ""}
            {...rest}
            className={`form-select d-print-none m-1 ${className}`}
            onChange={onChange}
          >
            <option value="" />
            {options &&
              options.map((option, index) => (
                <option
                  key={`${option._id}${index}`}
                  value={option._id}
                  title={option.title}
                >
                  {option.name}
                </option>
              ))}
          </select>
        );
      case "checkbox":
        return (
          <div className={`form-control d-print-none ${className}`}>
            <input
              {...rest}
              name={name}
              id={name}
              placeholder={placeholder}
              checked={checked || false}
              onChange={onChange}
              type="checkbox"
              className="form-check cbox m-1"
            />
          </div>
        );
      default:
        return (
          <input
            {...rest}
            name={name}
            id={name}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            type={type}
            className={
              className ? `${className} form-control m-1` : "form-control m-1"
            }
            style={style}
          />
        );
    }
  };

  return (
    <div
      className={`form-floating ${type === "checkbox" ? "pt-1 ps-1" : ""}`}
      title={tooltip}
    >
      {inputType()}
      <label
        htmlFor={name}
        className={
          type !== "checkbox"
            ? "form-label text-dark"
            : "form-check-label text-dark"
        }
      >
        {label}{" "}
        {tooltip !== undefined ? <i className="fas fa-info-circle"></i> : null}
      </label>
    </div>
  );
}

export default FloatingInput;
